import TreeNodeType from './TreeNodeType';

type Identifiant = number | string;

/**
 * Clés des lignes de la treeview d'ordonnancement (rowKey) : seule source pour les construire. La relecture après
 * la fiche, la suppression et le déplacement retrouvent les lignes par ces clés : une clé écrite à la main ailleurs
 * ne correspondrait plus. Le préfixe est le type de la ligne (TreeNodeType).
 */
const TreeRowKey = {
	entite: (identifiant: Identifiant) => `${TreeNodeType.ENTITE}-${identifiant}`,
	bordereau: (identifiant: Identifiant) =>
		`${TreeNodeType.BORDEREAU}-${identifiant}`,
	mouvement: (identifiant: Identifiant) =>
		`${TreeNodeType.MOUVEMENT}-${identifiant}`,
	/** Ligne « Créer un mandat / titre » d'un bordereau en brouillard. */
	creationMouvement: (identifiantBordereau: Identifiant) =>
		`${TreeNodeType.MOUVEMENT}-create-${identifiantBordereau}`,
	/** Bordereau de travail (à créer) d'une entité, par sens, ordinaire ou d'annulation. */
	bordereauTravail: (
		entiteKey: string,
		isMandat: boolean,
		isAnnulation: boolean,
	) =>
		`${TreeNodeType.BORDEREAU}-new-${isAnnulation ? 'annulation-' : ''}${isMandat ? 'depense' : 'recette'}-${entiteKey}`,
	/** Ligne « Créer un mandat / titre » d'un bordereau de travail. */
	creationMouvementTravail: (
		entiteKey: string,
		isMandat: boolean,
		isAnnulation: boolean,
	) =>
		`${TreeNodeType.MOUVEMENT}-create-${isAnnulation ? 'annulation-' : ''}${isMandat ? 'mandat' : 'titre'}-${entiteKey}`,
} as const;

export default TreeRowKey;
